module.exports = __webpack_public_path__ + "img/canbadge_square_44mm.d47908fc.png";